import firebase from 'firebase';
// Required for side-effects
import 'firebase/firestore';

firebase.initializeApp({
    apiKey: 'AIzaSyDCeQIhbuvK-nWNhBZ_FwgrklePo2AbZA4',
    authDomain: 'rf-app-journal.firebaseapp.com',
    projectId: 'rf-app-journal'
});
